import React from "react";
import { HistoryDetailsItem } from "@common/types/auditLog";
import { TaskDetail } from "@components/tasks/TaskDetail/TaskDetail";
import { extractTaskSnapshot } from "./utils/taskSnapshotAdapter";
import styles from "./HistoryTaskLog.module.scss";

interface Props {
    log: HistoryDetailsItem;
}

export const HistoryTaskSnapshotLog: React.FC<Props> = ({ log }) => {
    const snapshot = extractTaskSnapshot(log);

    if (!snapshot) {
        return (
            <article className={styles.taskLogItem}>
                <p className={styles.taskLogSnapshotEmpty}>
                    Task snapshot is not available for this entry.
                </p>
            </article>
        );
    }

    return (
        <article className={styles.taskLogItem}>
            <h3 className={styles.taskLogTitle}>{snapshot.title}</h3>
            <TaskDetail task={snapshot} readonly />
        </article>
    );
};
